import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { GraphGranularity } from '../../../__generated__/graphql'

dayjs.extend(utc)
dayjs.extend(timezone)

export const CHART_DATE_FORMAT: Record<GraphGranularity, string> = {
  [GraphGranularity.All]: 'all',
  [GraphGranularity.Hour]: 'D MMM YYYY HH:mm',
  [GraphGranularity.Day]: 'D MMM YYYY - dddd',
  [GraphGranularity.Week]: 'D MMM YYYY - dddd',
  [GraphGranularity.Month]: 'MMM YYYY',
  [GraphGranularity.Quarter]: 'Q YYYY',
  [GraphGranularity.Year]: 'YYYY',
}

export const SINGLE_DAY_CHART_DATE_FORMAT = 'HH:mm'

const CHART_DATE_FORMAT_SAME_YEAR: Partial<Record<GraphGranularity, string>> = {
  [GraphGranularity.Hour]: 'D MMM HH:mm',
  [GraphGranularity.Day]: 'D MMM - dddd',
  [GraphGranularity.Week]: 'D MMM - dddd',
}

export const isSingleDayRange = (startDate: string, endDate: string, timeZone: string): boolean => {
  const start = dayjs(startDate).tz(timeZone).startOf('day')
  const end = dayjs(endDate).tz(timeZone).startOf('day')

  return start.isSame(end, 'day')
}

export const isSameYearRange = (startDate: string, endDate: string, timeZone: string): boolean => {
  const start = dayjs(startDate).tz(timeZone)
  const end = dayjs(endDate).tz(timeZone)

  return start.year() === end.year()
}

export const getChartDateFormat = (
  granularity: GraphGranularity,
  startDate: string,
  endDate: string,
  timeZone: string
): string => {
  if (granularity === GraphGranularity.Hour && isSingleDayRange(startDate, endDate, timeZone))
    return SINGLE_DAY_CHART_DATE_FORMAT

  if (
    isSameYearRange(startDate, endDate, timeZone) &&
    (granularity === GraphGranularity.Hour ||
      granularity === GraphGranularity.Day ||
      granularity === GraphGranularity.Week)
  )
    return CHART_DATE_FORMAT_SAME_YEAR[granularity] ?? CHART_DATE_FORMAT[granularity]

  return CHART_DATE_FORMAT[granularity]
}
